import { css } from 'lit';
const styles = css`.cre8-u-content-knockout-brand {
  color: var(--cre8-color-content-knockout-brand);
}

.cre8-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

.cre8-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

@media all and (min-width: 23.4375rem) {
  .cre8-u-hide-sm {
    display: none !important;
  }
}
@media all and (min-width: 35rem) {
  .cre8-u-hide-sm-2 {
    display: none !important;
  }
}
@media all and (min-width: 48rem) {
  .cre8-u-hide-md {
    display: none !important;
  }
}
@media all and (min-width: 60rem) {
  .cre8-u-hide-lg {
    display: none !important;
  }
}
@media all and (min-width: 75rem) {
  .cre8-u-hide-xl {
    display: none !important;
  }
}
@media all and (max-width: 23.4375rem) {
  .cre8-u-show-sm {
    display: none !important;
  }
}
@media all and (max-width: 35rem) {
  .cre8-u-show-sm-2 {
    display: none !important;
  }
}
@media all and (max-width: 48rem) {
  .cre8-u-show-md {
    display: none !important;
  }
}
@media all and (max-width: 60rem) {
  .cre8-u-show-lg {
    display: none !important;
  }
}
@media all and (max-width: 75rem) {
  .cre8-u-show-xl {
    display: none !important;
  }
}
.cre8-u-margin-none {
  margin: 0 !important;
}

.cre8-u-margin-sm {
  margin: 0.5rem !important;
}

.cre8-u-margin-md {
  margin: 1rem !important;
}

.cre8-u-margin-lg {
  margin: 1.5rem !important;
}

.cre8-u-margin-xl {
  margin: 2rem !important;
}

.cre8-u-margin-xxl {
  margin: 4rem !important;
}

.cre8-u-margin-top-none {
  margin-top: 0 !important;
}

.cre8-u-margin-top-sm {
  margin-top: 0.5rem !important;
}

.cre8-u-margin-top-md {
  margin-top: 1rem !important;
}

.cre8-u-margin-top-lg {
  margin-top: 1.5rem !important;
}

.cre8-u-margin-top-xl {
  margin-top: 2rem !important;
}

.cre8-u-margin-top-xxl {
  margin-top: 4rem !important;
}

.cre8-u-margin-right-none {
  margin-right: 0 !important;
}

.cre8-u-margin-right-sm {
  margin-right: 0.5rem !important;
}

.cre8-u-margin-right-md {
  margin-right: 1rem !important;
}

.cre8-u-margin-right-lg {
  margin-right: 1.5rem !important;
}

.cre8-u-margin-right-xl {
  margin-right: 2rem !important;
}

.cre8-u-margin-right-xxl {
  margin-right: 4rem !important;
}

.cre8-u-margin-bottom-none {
  margin-bottom: 0 !important;
}

.cre8-u-margin-bottom-sm {
  margin-bottom: 0.5rem !important;
}

.cre8-u-margin-bottom-md {
  margin-bottom: 1rem !important;
}

.cre8-u-margin-bottom-lg {
  margin-bottom: 1.5rem !important;
}

.cre8-u-margin-bottom-xl {
  margin-bottom: 2rem !important;
}

.cre8-u-margin-bottom-xxl {
  margin-bottom: 4rem !important;
}

.cre8-u-margin-bottom-xl-xxl {
  margin-bottom: 2rem !important;
}

@media all and (min-width: 768px) {
  .cre8-u-margin-bottom-xl-xxl {
    margin-bottom: 4rem !important;
  }
}
.cre8-u-margin-left-none {
  margin-left: 0 !important;
}

.cre8-u-margin-left-sm {
  margin-left: 0.5rem !important;
}

.cre8-u-margin-left-md {
  margin-left: 1rem !important;
}

.cre8-u-margin-left-lg {
  margin-left: 1.5rem !important;
}

.cre8-u-margin-left-xl {
  margin-left: 2rem !important;
}

.cre8-u-margin-left-xxl {
  margin-left: 4rem !important;
}

.cre8-u-padding-none {
  padding: 0 !important;
}

.cre8-u-padding-sm {
  padding: 0.5rem !important;
}

.cre8-u-padding-md {
  padding: 1rem !important;
}

.cre8-u-padding-lg {
  padding: 1.5rem !important;
}

.cre8-u-padding-xl {
  padding: 2rem !important;
}

.cre8-u-padding-xxl {
  padding: 4rem !important;
}

.cre8-u-padding-top-none {
  padding-top: 0 !important;
}

.cre8-u-padding-top-sm {
  padding-top: 0.5rem !important;
}

.cre8-u-padding-top-md {
  padding-top: 1rem !important;
}

.cre8-u-padding-top-lg {
  padding-top: 1.5rem !important;
}

.cre8-u-padding-top-xl {
  padding-top: 2rem !important;
}

.cre8-u-padding-top-xxl {
  padding-top: 4rem !important;
}

.cre8-u-padding-right-none {
  padding-right: 0 !important;
}

.cre8-u-padding-right-sm {
  padding-right: 0.5rem !important;
}

.cre8-u-padding-right-md {
  padding-right: 1rem !important;
}

.cre8-u-padding-right-lg {
  padding-right: 1.5rem !important;
}

.cre8-u-padding-right-xl {
  padding-right: 2rem !important;
}

.cre8-u-padding-right-xxl {
  padding-right: 4rem !important;
}

.cre8-u-padding-bottom-none {
  padding-bottom: 0 !important;
}

.cre8-u-padding-bottom-sm {
  padding-bottom: 0.5rem !important;
}

.cre8-u-padding-bottom-md {
  padding-bottom: 1rem !important;
}

.cre8-u-padding-bottom-lg {
  padding-bottom: 1.5rem !important;
}

.cre8-u-padding-bottom-xl {
  padding-bottom: 2rem !important;
}

.cre8-u-padding-bottom-xxl {
  padding-bottom: 4rem !important;
}

.cre8-u-padding-left-none {
  padding-left: 0 !important;
}

.cre8-u-padding-left-sm {
  padding-left: 0.5rem !important;
}

.cre8-u-padding-left-md {
  padding-left: 1rem !important;
}

.cre8-u-padding-left-lg {
  padding-left: 1.5rem !important;
}

.cre8-u-padding-left-xl {
  padding-left: 2rem !important;
}

.cre8-u-padding-left-xxl {
  padding-left: 4rem !important;
}

.cre8-u-display-flex {
  display: flex !important;
}

.cre8-u-display-block {
  display: block !important;
}

body {
  font-family: var(--cre8-typography-body-default-font-family);
  font-size: var(--cre8-typography-body-default-font-size);
  font-weight: var(--cre8-typography-body-default-font-weight);
  line-height: var(--cre8-typography-body-default-line-height);
  text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-transform: var(--cre8-typography-body-default-text-transform);
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  color: var(--cre8-color-content-default);
  background: var(--cre8-color-bg-default);
}

@media all and (min-width: 60rem) {
  .page-container {
    background: linear-gradient(90deg, #fff 0, #fff 66.66%, #f8f8f9 0, #f8f8f9 0);
  }
}
.band__inner {
  margin-left: 2rem;
  margin-right: 2rem;
}

@media all and (min-width: 60rem) {
  .band__inner {
    margin-right: 0;
  }
}
img {
  max-width: 100%;
  height: auto;
}

/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:root {
  --size-base-unit: 0.5rem;
  --cre8-l-max-width: 82.5rem;
  /* 1 */
  --cre8-l-linelength-width: 42rem;
  /* 1 */
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/*
=======
Animations
=======
*/
:host {
  --cre8-z-index-1: 1;
  --cre8-z-index-50: 50;
  --cre8-z-index-100: 100;
  --cre8-z-index-200: 200;
  --cre8-z-index-1030: 1030;
  --cre8-anim-fade-quick: 0.35s;
  --cre8-anim-ease: ease;
}

@keyframes fadeIn {
  100% {
    opacity: 1;
  }
}
@keyframes slideIn {
  100% {
    transform: translateX(0);
  }
}
@keyframes slideInFwd {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideOutRight {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideUp {
  100% {
    transform: translateY(0);
  }
}
@media (width >= 481px) {
  @keyframes slideInFwd {
    100% {
      width: 417px;
      height: 417px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 417px;
      height: 417px;
    }
  }
}
@media (width >= 48rem) {
  @keyframes slideInFwd {
    100% {
      width: 330px;
      height: 330px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 330px;
      height: 330px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 60rem) {
  @keyframes slideInFwd {
    100% {
      width: 460px;
      height: 460px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 460px;
      height: 460px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 75rem) {
  @keyframes slideInFwd {
    100% {
      width: 592px;
      height: 591px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 87.5rem) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 120px));
    }
  }
}
@media (width >= 2200px) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 592px));
    }
  }
}
span.ripple {
  position: absolute;
  border-radius: 50%;
  transform: scale(0);
  animation: ripple 600ms linear;
  background-color: var(--ripple-bg-color);
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 1;
  }
}
:root {
  --size-base-unit: 0.5rem;
  --cre8-l-max-width: 82.5rem;
  /* 1 */
  --cre8-l-linelength-width: 42rem;
  /* 1 */
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
:host {
  display: inline-flex;
}

.cre8-c-link {
  display: inline-flex;
  text-decoration: none;
  height: 100%;
  color: var(--cre8-color-content-link);
}
.cre8-c-link:hover .cre8-c-link__text,
.cre8-c-link:hover .cre8-c-link__text-area {
  color: var(--cre8-color-content-link-hover);
  border-color: var(--cre8-color-border-transparent);
  background-color: var(--cre8-color-bg-opacity-transparent);
}
.cre8-c-link:focus {
  outline: none;
}
.cre8-c-link:focus .cre8-c-link__text,
.cre8-c-link:focus .cre8-c-link__text-area {
  border-color: var(--cre8-color-border-transparent);
  background-color: var(--cre8-color-bg-active);
  color: var(--cre8-color-content-link-focus);
}
.cre8-c-link:focus .cre8-c-link__cta-wrapper {
  color: var(--cre8-color-content-link-focus);
  outline: var(--cre8-border-width-focus) solid var(--cre8-color-border-active-outline);
  outline-offset: 0.125rem;
  background-color: var(--cre8-color-button-primary-bg-hover);
  border: var(--cre8-border-width-focus) var(--cre8-border-style-default) var(--color-border-active-outline);
}
.cre8-c-link:active .cre8-c-link__text,
.cre8-c-link:active .cre8-c-link__text-area {
  border-color: var(--cre8-color-border-transparent);
  background-color: var(--cre8-color-bg-opacity-transparent);
  color: var(--cre8-color-content-link-active);
}

.cre8-c-link__text-area {
  display: inline-flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.cre8-c-link__text {
  font-family: var(--cre8-typography-body-default-link-font-family);
  font-size: var(--cre8-typography-body-default-link-font-size);
  font-weight: var(--cre8-typography-body-default-link-font-weight);
  line-height: var(--cre8-typography-body-default-link-line-height);
  text-decoration: var(--cre8-typography-body-default-link-text-decoration);
  text-transform: var(--cre8-typography-body-default-link-text-transform);
  color: var(--cre8-color-content-link);
  display: inline-flex;
}
.cre8-c-link--sm .cre8-c-link__text {
  font-family: var(--cre8-typography-body-small-link-font-family);
  font-size: var(--cre8-typography-body-small-link-font-size);
  font-weight: var(--cre8-typography-body-small-link-font-weight);
  line-height: var(--cre8-typography-body-small-link-line-height);
  text-decoration: var(--cre8-typography-body-small-link-text-decoration);
  text-transform: var(--cre8-typography-body-small-link-text-transform);
}
.cre8-c-link--lg .cre8-c-link__text {
  font-family: var(--cre8-typography-body-large-link-font-family);
  font-size: var(--cre8-typography-body-large-link-font-size);
  font-weight: var(--cre8-typography-body-large-link-font-weight);
  line-height: var(--cre8-typography-body-large-link-line-height);
  text-decoration: var(--cre8-typography-body-large-link-text-decoration);
  text-transform: var(--cre8-typography-body-large-link-text-transform);
}

.cre8-c-link__no-underline .cre8-c-link__text {
  text-decoration: none;
}

.cre8-c-link__icon-wrapper {
  display: inline-flex;
}

.cre8-c-link__icon {
  display: inline-flex;
  height: 1.5rem;
  width: 1.5rem;
}
.cre8-c-link--sm .cre8-c-link__icon {
  --cre8-icon-height: var(--cre8-icon-size-small);
  --cre8-icon-width: var(--cre8-icon-size-small);
  height: 1.375rem;
  width: 1.375rem;
}
.cre8-c-link--lg .cre8-c-link__icon {
  --cre8-icon-height: var(--cre8-icon-size-large);
  --cre8-icon-width: var(--cre8-icon-size-large);
  height: 1.625rem;
  width: 1.625rem;
}

.cre8-c-link__variation {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.cre8-c-link__cta-wrapper {
  color: var(--cre8-color-button-primary-content);
  display: inline-flex;
  margin-left: var(--cre8-spacing-8);
  padding: var(--cre8-spacing-4);
  background-color: var(--cre8-color-content-link);
  border-radius: var(--cre8-border-radius-round);
  border-width: var(--cre8-border-width-button-default);
}
.cre8-c-link__cta-wrapper svg {
  height: 1rem;
  width: 1rem;
}

.cre8-c-link__icon.before {
  padding-right: var(--cre8-padding-8);
}

.cre8-c-link__icon.after {
  padding-left: var(--cre8-padding-8);
}

::slotted([slot=badge]) {
  padding-left: var(--cre8-padding-8);
}

.cre8-c-link--inverted .cre8-c-link__text {
  color: var(--cre8-color-content-inverse-link);
}
.cre8-c-link--inverted .cre8-c-link__icon {
  color: var(--cre8-color-content-inverse-link);
}
.cre8-c-link--inverted .cre8-c-link__cta-wrapper {
  --cre8-icon-fill: var(--cre8-color-content-brand);
  color: var(--cre8-color-content-brand);
  background-color: var(--cre8-color-content-inverse-link);
}
.cre8-c-link--inverted:hover .cre8-c-link__text,
.cre8-c-link--inverted:hover .cre8-c-link__text-area {
  color: var(--cre8-color-content-inverse-link-hover);
}
.cre8-c-link--inverted:hover .cre8-c-link__icon {
  fill: var(--cre8-color-content-inverse-link-hover);
}
.cre8-c-link--inverted:active .cre8-c-link__text,
.cre8-c-link--inverted:active .cre8-c-link__text-area {
  color: var(--cre8-color-content-inverse-link-active);
}
.cre8-c-link--inverted:active .cre8-c-link__icon {
  fill: var(--cre8-color-content-inverse-link-active);
}
.cre8-c-link--inverted:focus {
  outline: none;
}
.cre8-c-link--inverted:focus .cre8-c-link__icon {
  background-color: var(--cre8-color-bg-inverse-active);
  fill: var(--cre8-color-content-inverse-link-focus);
}
.cre8-c-link--inverted:focus .cre8-c-link__text,
.cre8-c-link--inverted:focus .cre8-c-link__text-area {
  background-color: var(--cre8-color-bg-inverse-active);
  color: var(--cre8-color-content-inverse-link-focus);
}
.cre8-c-link--inverted:focus .cre8-c-link__cta-wrapper {
  background-color: var(--cre8-color-content-inverse-link);
  color: var(--cre8-color-content-inverse-link-focus);
  outline: var(--cre8-border-width-focus) var(--cre8-border-style-default) var(--cre8-color-content-inverse-link);
  outline-offset: 0.125rem;
}

cre8-icon {
  display: flex;
  align-items: center;
}`;
export default styles;
